export const lang = {
    account: 'account',
    password: 'password',
    nickname: 'nickname',
    accountInfo: 'please enter account number',
    passwordInfo: 'please enter password',

    passwordInfo1: 'please enter the password again',

    passwordInfo2: 'the two input passwords are inconsistent',
    nicknameInfo: 'please enter your nickname',
    login: 'login',
    register: 'register',
    language: 'language',
    zh: 'Chinese',
    en: 'English',
    loginError1: 'Account password cannot be empty',
    loginError2: 'password error',
    loginError3: 'Account does not exist',

    loginError4: 'do not login repeatedly',
    loginError5: 'account is not a mobile phone number',
    
    loginSuccess: 'login success',
    function1: "location roaming",
    function2: "custom skin",
    function3: "interactive action",
    function4: 'user manage',
    logOut: 'log out',
    logOutInfo: 'exit login?',
    close: 'close',
    online: 'online',
    AccName: [
        "Sex",
        "Accessory",
        "Hair",
        "Hat",
        "Suit",
        "Hair color",
        "Skin color"
    ],
    sendError: 'The content you sent cannot be empty',
    sendInfo: 'please enter content',
    send: 'send',
    peopleOnline: 'people online',
    world: 'world',
    clientError: "You haven't entered the conference room yet, so you don't have permission",
    videoError: "you don't have a camera",
    micError: `you don't have a microphone, failed to enter the room`,
    saveInfo: 'Saved successfully',
    shareError: 'someone has shared the screen at present',
}

